import { render, staticRenderFns } from "./OverViews.vue?vue&type=template&id=41657938&scoped=true"
import script from "./OverViews.vue?vue&type=script&lang=js"
export * from "./OverViews.vue?vue&type=script&lang=js"
import style0 from "./OverViews.vue?vue&type=style&index=0&id=41657938&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41657938",
  null
  
)

export default component.exports